import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { Dialog, DialogContent } from "design-system/atoms/Dialog"
import { BackofficeCompanyCreatorFromWebsite } from "modules/backoffice/components/companies/BackofficeCompanyCreatorFromWebsite"
import { Route as OrganizationsListRoute } from "routes/_base/_auth/backoffice/organizations/list"

export const Route = createFileRoute(
  "/_base/_auth/backoffice/organizations/list/create-from-website",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const search = OrganizationsListRoute.useSearch()
  const navigate = useNavigate()

  function onClose() {
    navigate({ to: "/backoffice/organizations/list", search })
  }

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent size="lg" className="max-h-[90vh] overflow-y-auto">
        <BackofficeCompanyCreatorFromWebsite />
      </DialogContent>
    </Dialog>
  )
}
